/**
 * AdSense feature-flag configuration (web only).
 *
 * Ads are disabled by default and only activate when both the global flag is
 * enabled and a publisher client id is provided. This keeps the desktop build
 * and any unconfigured deployment completely ad-free, satisfying the migration
 * plan's "feature flag to disable ads globally" and rollback requirements.
 */

function readEnv(key: string): string | undefined {
  const value = import.meta.env[key as keyof ImportMetaEnv] as string | undefined
  const trimmed = value?.trim()
  return trimmed ? trimmed : undefined
}

export const adsenseClient = readEnv('VITE_ADSENSE_CLIENT')

export const adsenseSlot = readEnv('VITE_ADSENSE_SLOT')

/** Global kill switch. Ads only render when explicitly enabled and configured. */
export const isAdsEnabled = readEnv('VITE_ENABLE_ADS') === 'true' && Boolean(adsenseClient)

/** Slot-backed banner rendering requires a configured slot id. */
export const isAdSlotConfigured = Boolean(adsenseSlot)
